import { render } from "./DeviceGrade.vue?vue&type=template&id=bbbe1f1e&scoped=true&ts=true&lang=pug"
import script from "./DeviceGrade.vue?vue&type=script&lang=ts"
export * from "./DeviceGrade.vue?vue&type=script&lang=ts"

import "./DeviceGrade.vue?vue&type=style&index=0&id=bbbe1f1e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbbe1f1e"]])

export default __exports__